import stockAPI from "@/utility/api.js";

export default {
  async FETCH_CHART_PROFIT_YEAR({ commit, rootState }) {
    try {
      const res = await stockAPI.GET(
        `/api/chart/profit/year/${rootState.stockSymbol}`
      );
      commit("chartProfitYear", res);
      // 共用 rootState 儲存股票代號。
      commit("storageCompanyName", res);
      // 共用 rootState 儲存公司等級、昨收。
      commit("companyInfoInChartTitle", res);
      // 成功即清除錯誤訊息，回傳預設空值。
      commit("fetchErrorMessage", null);
    } catch ({ message }) {
      // 提示錯誤訊息，優化使用者機制。
      commit("fetchErrorMessage", message);
      console.error(message);
    }
  },
  async FETCH_CHART_PROFIT_QUARTER({ commit, rootState }) {
    try {
      const res = await stockAPI.GET(
        `/api/chart/profit/quarter/${rootState.stockSymbol}`
      );
      commit("chartProfitQuarter", res);
      // 共用 rootState 儲存股票代號。
      commit("storageCompanyName", res);
      // 共用 rootState 儲存公司等級、昨收。
      commit("companyInfoInChartTitle", res);
      commit("fetchErrorMessage", null);
    } catch ({ message }) {
      // 提示錯誤訊息，優化使用者機制。
      commit("fetchErrorMessage", message);
      console.error(message);
    }
  }
};
